import React from "react";

interface RadioGroupProps {
  options: string[];
  selectedValue: string;
  onChange: (value: string) => void;
  name: string;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  disabledOptions?: string[];
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  options,
  selectedValue,
  onChange,
  name,
  style,
  labelStyle,
  disabledOptions = []
}) => {
  return (
    <div style={style}>
      {options.map((option) => (
        <label key={option} style={{ marginRight: "10px", ...labelStyle }}>
          <input
            type="radio"
            name={name}
            value={option}
            checked={selectedValue === option}
            onChange={() => onChange(option)}
            disabled={disabledOptions.includes(option)}
          />{" "}
          {option}
        </label>
      ))}
    </div>
  );
};

export default RadioGroup;
